const NON_TEXT_INPUT_TYPES = new Set([
	'button',
	'checkbox',
	'color',
	'file',
	'hidden',
	'image',
	'radio',
	'range',
	'reset',
	'submit',
])

export function isTypingTarget(target: EventTarget | null): boolean {
	if (target instanceof HTMLInputElement) {
		return !NON_TEXT_INPUT_TYPES.has(target.type)
	}
	if (!(target instanceof HTMLElement)) {
		return false
	}
	return target.isContentEditable || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement
}

let keyboardFocused: Element | null = null

// :focus-visible tells keyboard focus from a click only as focus lands: any later key press turns it on.
// A click or tap on the focused element moves no focus, so it resets the flag itself.
if (typeof document !== 'undefined') {
	document.addEventListener(
		'focusin',
		event => {
			keyboardFocused = event.target instanceof Element && event.target.matches(':focus-visible') ? event.target : null
		},
		true,
	)
	document.addEventListener(
		'pointerdown',
		() => {
			keyboardFocused = null
		},
		true,
	)
}

export function holdsKeyboardFocus(target: EventTarget | null): boolean {
	return target !== null && target === keyboardFocused && target === document.activeElement
}

function isComposing(event: KeyboardEvent): boolean {
	return event.isComposing || event.keyCode === 229
}

export function shouldSkipShortcut(event: KeyboardEvent, { inTextFields = false } = {}): boolean {
	return event.defaultPrevented || event.repeat || isComposing(event) || (!inTextFields && isTypingTarget(event.target))
}
